import { render, staticRenderFns } from "./PersistentTaskProgressMonitorAlert.vue?vue&type=template&id=269dae38"
import script from "./PersistentTaskProgressMonitorAlert.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersistentTaskProgressMonitorAlert.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports